import React from 'react';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { removeDeviations, RemoveDeviationsPayload } from '../../actions';
import ItemControlButtons from '../ItemControlButtons';

export interface Props {
  className?: string;
  deviation: PapiDeviation;
}

type DispatchProps = {
  removeDeviations: (payload: RemoveDeviationsPayload) => void;
};

const enhance = compose(
  connectMediaStore<{}, DispatchProps, Props>(null, { removeDeviations }),
  withTranslation()
);
export class CustomSetDeviationControlButtons extends React.Component<
  Props & WithTranslation & DispatchProps
> {
  render() {
    const { className } = this.props;
    return (
      <ItemControlButtons
        className={className}
        withOneClickDelete={true}
        onDelete={this.onDelete}
      />
    );
  }

  onDelete = () => {
    this.props.removeDeviations([this.props.deviation]);
  };
}

export default enhance(CustomSetDeviationControlButtons);
